import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import type { ClosedWonRepRow } from '@/models/salesAnalytics'

const money = (n: number) =>
  n.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })

export function ClosedWonByRepCard({ rows }: { rows: ClosedWonRepRow[] }) {
  const totalPremium = rows.reduce((sum, row) => sum + row.premium, 0)
  const topShare = rows.length > 0 && totalPremium > 0 ? rows[0].premium / totalPremium : 0

  return (
    <Card>
      <CardHeader>
        <CardTitle>Closed won by rep</CardTitle>
        <p className="text-sm text-neutral-500">
          Credited on bound date — when the deal was won, not when the premium starts earning. Attributed by
          the customer&apos;s sales owner; a customer split across business entities counts as one account.
        </p>
      </CardHeader>
      <CardContent className="flex flex-col gap-3">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Rep</TableHead>
              <TableHead className="text-right">Accounts</TableHead>
              <TableHead className="text-right">Policies</TableHead>
              <TableHead className="text-right">Premium</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.repId || row.repName}>
                <TableCell>{row.repName}</TableCell>
                <TableCell className="text-right tabular-nums">{row.accounts}</TableCell>
                <TableCell className="text-right tabular-nums">{row.policies}</TableCell>
                <TableCell className="text-right tabular-nums">{money(row.premium)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {topShare > 0.5 && (
          <p className="text-sm text-amber-700 dark:text-amber-400">
            {rows[0].repName} holds {Math.round(topShare * 100)}% of all premium, concentrated in a single
            account — read the accounts column alongside the dollars before comparing reps.
          </p>
        )}
      </CardContent>
    </Card>
  )
}
